/*
 * BudgetKicks cart enhancements
 * - Intercepts non-AJAX add-to-cart forms (custom PDP) so the cart DRAWER opens
 *   instead of redirecting to /cart.
 * - Auto-adds ONE free "Mystery Jersey" whenever the cart has a real item
 *   (capped at qty 1, removed when the cart is emptied).
 * - Adds an opt-out "Shipping Protection" add-on, controlled by the drawer toggle.
 * - Keeps the drawer in sync after any Shrine cart update.
 */
(function () {
  'use strict';

  var MYSTERY_VID = 47122458837148;
  var PROTECT_VID = 47122458869916;
  var GIFT_NOTE = 'Free Mystery Jersey 🎁';

  var root =
    (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  function addRaw(id, qty, props) {
    var body = { id: id, quantity: qty };
    if (props) body.properties = props;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
  }

  function changeRaw(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
  }

  /* One reconcile pass: align the gift + protection lines with the real items. */
  function reconcileOnce() {
    var changed = false;

    return getCart()
      .then(function (cart) {
        var real = cart.items.filter(function (i) {
          return i.variant_id !== MYSTERY_VID && i.variant_id !== PROTECT_VID;
        });
        var mystery = cart.items.filter(function (i) { return i.variant_id === MYSTERY_VID; })[0];
        var protect = cart.items.filter(function (i) { return i.variant_id === PROTECT_VID; })[0];

        var chain = Promise.resolve();

        if (real.length > 0) {
          if (!mystery) {
            chain = chain.then(function () { changed = true; return addRaw(MYSTERY_VID, 1, { _gift: GIFT_NOTE }); });
          } else if (mystery.quantity !== 1) {
            chain = chain.then(function () { changed = true; return changeRaw(mystery.key, 1); });
          }
        } else if (mystery) {
          // No paid products -> strip the gift.
          chain = chain.then(function () { changed = true; return changeRaw(mystery.key, 0); });
        }

        // Shipping protection is disabled for now: remove it from any cart that has it.
        if (protect) {
          chain = chain.then(function () { changed = true; return changeRaw(protect.key, 0); });
        }

        return chain;
      })
      .catch(function (e) { console.warn('[bk] sync', e); })
      .then(function () { return changed; });
  }

  /*
   * Serialise reconcile passes. If a cart update lands while a pass is running,
   * we QUEUE a trailing pass instead of dropping it — otherwise clearing the
   * cart mid-sync could leave the free gift stranded. The original caller's
   * promise resolves only after all queued passes finish, with cumulative
   * "changed" so the drawer is always re-rendered to the final state.
   */
  var bkSyncing = false;
  var bkQueued = false;
  function bkCartSync() {
    if (bkSyncing) {
      bkQueued = true;
      return Promise.resolve(false);
    }
    bkSyncing = true;
    return reconcileOnce().then(function (changed) {
      bkSyncing = false;
      if (bkQueued) {
        bkQueued = false;
        return bkCartSync().then(function (c2) { return changed || c2; });
      }
      return changed;
    });
  }

  /* Pull fresh drawer markup and swap it in; optionally open the drawer. */
  function renderDrawer(openIt) {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wrapper = document.querySelector('cart-drawer');

        if (data['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var freshInner = doc.getElementById('CartDrawer');
          var cd = document.getElementById('CartDrawer');
          if (cd && freshInner) cd.innerHTML = freshInner.innerHTML;

          var freshWrap = doc.querySelector('cart-drawer');
          if (wrapper && freshWrap) {
            wrapper.classList.toggle('is-empty', freshWrap.classList.contains('is-empty'));
          }
        }

        if (data['cart-icon-bubble']) {
          var doc2 = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          var fb = doc2.querySelector('.shopify-section');
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && fb) bubble.innerHTML = fb.innerHTML;
        }

        // Re-bind overlay click-to-close (innerHTML swap replaced the node).
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov && wrapper) ov.addEventListener('click', wrapper.close.bind(wrapper));

        if (openIt && wrapper) wrapper.open();
      })
      .catch(function (e) { console.warn('[bk] render', e); });
  }

  /* AJAX-handle add-to-cart forms that Shrine's <product-form> does NOT own. */
  function handleCustomAdd(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }

    var fd = new FormData(form);

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return bkCartSync(); })
      .then(function () { return renderDrawer(true); })
      .catch(function (e) { console.warn('[bk] add', e); })
      .then(function () {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
      });
  }

  // Bubble phase: runs AFTER a form's own submit handler (e.g. the PDP's
  // print-validation / setProps), and we honour any preventDefault it made.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return; // only add-to-cart forms
    if (form.closest('product-form')) return; // Shrine already AJAX-handles these
    if (e.defaultPrevented) return; // the form's own validation blocked it
    e.preventDefault();
    handleCustomAdd(form);
  });

  /*
   * Safety net: any remove / quantity change inside the drawer schedules a
   * reconcile shortly after Shrine has processed it. This GUARANTEES the gift
   * (and protection) are stripped once no paid products remain, independently
   * of Shrine's pub/sub firing.
   */
  var bkReconcileTimer = null;
  function scheduleReconcile() {
    if (bkReconcileTimer) clearTimeout(bkReconcileTimer);
    bkReconcileTimer = setTimeout(function () {
      bkCartSync().then(function (changed) { if (changed) renderDrawer(false); });
    }, 550);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#CartDrawer cart-remove-button, #CartDrawer .quantity__button')) {
      scheduleReconcile();
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input') && t.closest && t.closest('#CartDrawer')) {
      scheduleReconcile();
    }
  });

  /*
   * Keep the gift correct after any Shrine-driven cart update (remove, qty change).
   * NOTE: the theme declares `subscribe`/`publish` as functions and
   * `PUB_SUB_EVENTS` as a top-level `const`. A `const` is a global identifier but
   * NOT a property of window, so `window.PUB_SUB_EVENTS` is undefined. We must
   * reference these by bare name (guarded with typeof) — checking window.* here
   * was the bug that stopped the gift from ever being removed on cart changes.
   */
  function wireCartUpdate() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        bkCartSync().then(function (changed) { if (changed) renderDrawer(false); });
      });
      return true;
    }
    return false;
  }

  if (!wireCartUpdate()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (wireCartUpdate() || ++tries > 40) clearInterval(iv);
    }, 150);
  }

  /* Reserved-for countdown shown in the drawer banner. */
  function startReservedTimer() {
    function tick() {
      var els = document.querySelectorAll('.bk-reserved-time');
      if (!els.length) return;
      var end = parseInt(sessionStorage.getItem('bk_resv_end') || '0', 10);
      var now = Date.now();
      if (!end || end < now) {
        end = now + 10 * 60 * 1000; // 10 minutes
        sessionStorage.setItem('bk_resv_end', String(end));
      }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var m = Math.floor(s / 60);
      var ss = s % 60;
      var txt = m + ':' + (ss < 10 ? '0' : '') + ss;
      for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* On first load, make sure an existing cart already carries the gift. */
  document.addEventListener('DOMContentLoaded', function () {
    startReservedTimer();
    getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      bkCartSync().then(function (changed) {
        if (changed) renderDrawer(false);
      });
    });
  });
})();
